import { connect } from 'react-redux';
import { checkLogin } from 'ducks/auth';
import { getFeatureFlags } from 'ducks/featureFlags';
import AppRoutes from './AppRoutes';

const mapStateToProps = (state) => {
  return {
    userId: state.auth.userId,
    isAuthenticated: state.auth.isAuthenticated,
    hasAcceptedTC: state.auth.hasAcceptedTC,
  };
};

const mapDispatchToProps = {
  checkLogin: checkLogin,
  getFeatureFlags,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppRoutes);
